var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "userInfo" }, [
    _c("div", { staticClass: "main-title" }, [_vm._v("完善信息")]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "changeTypesBox" },
      [
        _c(
          "el-radio",
          {
            attrs: { label: 2, disabled: _vm.state == 1 ? true : false },
            model: {
              value: _vm.type,
              callback: function($$v) {
                _vm.type = $$v
              },
              expression: "type"
            }
          },
          [_vm._v("个体经营")]
        ),
        _vm._v(" "),
        _c(
          "el-radio",
          {
            attrs: { label: 3, disabled: _vm.state == 1 ? true : false },
            model: {
              value: _vm.type,
              callback: function($$v) {
                _vm.type = $$v
              },
              expression: "type"
            }
          },
          [_vm._v("企业用户")]
        ),
        _vm._v(" "),
        _c(
          "el-radio",
          {
            attrs: { label: 4, disabled: _vm.state == 1 ? true : false },
            model: {
              value: _vm.type,
              callback: function($$v) {
                _vm.type = $$v
              },
              expression: "type"
            }
          },
          [_vm._v("事业单位或社会团体")]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "curTypebox" },
      [
        _vm.type == 2
          ? _c("SinglePerson", { attrs: { type: _vm.type } })
          : _vm._e(),
        _vm._v(" "),
        _vm.type == 3
          ? _c("CompanyPerson", { attrs: { type: _vm.type } })
          : _vm._e(),
        _vm._v(" "),
        _vm.type == 4
          ? _c("PublicInstitutionPerson", { attrs: { type: _vm.type } })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-7164f50c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-7164f50c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/userCenter/companyCertificate/companyCertificate.vue
// module id = null
// module chunks = 